import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  toolbarWrapper: {
    display: 'block',
    flex: '0 1 content',
  },
  pageWrapper: {
    display: 'block',
    flex: '1 1 0',
    height: 'calc(100% - 64px)',
  }
}));

interface Props {
  window?: any;
  title?: string;
  drawer?: any;
  children: React.ReactNode;
}

export default function FixedLayout(props: Props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.toolbarWrapper} >
        <div className={classes.toolbar} style={{ width: '100%' }} />
      </div>
      <div className={classes.pageWrapper}>
        {props.children}
      </div>
    </React.Fragment>
  );
}
